module.exports = __webpack_public_path__ + "img/icon_map_1_on_110.12569958.png";